import Vue from "vue";
import App from "./App.vue";
import store from "../store/index.js";
import vuetify from "./utils/vuetify.js";

import "vuetify/dist/vuetify.min.css";
import router from "./router";

Vue.config.productionTip = false;

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount("#app");
